import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { StylesProvider } from '@material-ui/core';
//import "bootstrap/dist/css/bootstrap.min.css";

import App from './App';

import * as serviceWorker from './serviceWorker';

const root = createRoot(document.getElementById('root'));
root.render(<StylesProvider injectFirst><App /></StylesProvider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register();
